module.exports = __webpack_public_path__ + "img/admission-5.e6e60a9b.jpg";